(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yd-product-features-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.yd-product-features-info-tab');
  const titleElement = document.querySelector('.yd-product-features-info-title-content h2');
  const contentBlocks = document.querySelectorAll('.yd-product-features-info-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Deactivate all tabs and hide all content
      tabs.forEach(t => t.classList.remove('active'));
      contentBlocks.forEach(block => block.style.display = 'none');

      // Activate clicked tab
      this.classList.add('active');

      const uuid = this.dataset.uuid;
      const title = this.dataset.title;

      // Update title
      if (titleElement) {
        titleElement.textContent = title;
      }

      // Show corresponding content block
      const selectedContent = document.querySelector(`.yd-product-features-info-content[data-uuid="${uuid}"]`);
      if (selectedContent) {
        selectedContent.style.display = 'flex';
      }
    });
  });

  // Set the first tab as active by default
  if (tabs.length > 0) {
    tabs[0].click();
  }

  function handleTabsLayout() {
    const tabsContainer = document.querySelector('.yd-product-features-info-tabs');
    if (!tabsContainer) return;

    if (window.innerWidth <= 1024) {
      const totalWidth = Array.from(tabs).reduce((acc, tab) => acc + tab.offsetWidth + parseInt(window.getComputedStyle(tab).marginRight), 0);
      if (totalWidth > tabsContainer.offsetWidth) {
        tabsContainer.style.justifyContent = 'flex-start';
      } else {
        tabsContainer.style.justifyContent = 'center';
      }
    } else {
      tabsContainer.style.justifyContent = 'center';
    }
  }

  handleTabsLayout();
  window.addEventListener('resize', handleTabsLayout);
});

  } catch(e) { console.error(e); }
})();
})();
